import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./KeyContactItem.module.css";

/**
 * View component. Displays info about key contacts.
 */
export function KeyContactItem({ contact, index }) {
  return (
    <div
      className={classNames(
        index % 2 === 0 ? styles.dark : null,
        styles.contactRow
      )}
    >
      <div className={styles.contactItem}>{contact.position}</div>
      <div className={styles.contactItem}>{contact.name}</div>
      <div className={styles.contactItem}>{contact.number}</div>
      <div className={styles.contactItem}>{contact.email}</div>
    </div>
  );
}

KeyContactItem.propTypes = {
  /**
   * Object with the contact info.
   */
  contact: PropTypes.shape({
    position: PropTypes.string,
    name: PropTypes.string,
    number: PropTypes.string,
    email: PropTypes.string,
  }),
  /**
   * Number used to display the background color.
   * If odd, background is dark.
   */
  index: PropTypes.number,
};
